export const createValidator = (findError, isInitial) => (value) => {
    if (isInitial(value))
        return { kind: 'initial', value };
    const message = findError(value);
    return Object.assign({ value }, message ? { kind: 'error', message } : { kind: 'ok' });
};
